
import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import NewBanner from "@/components/sections/NewBanner";
import NewSectionTwo from "@/components/sections/NewSectionTwo";
import SectionThree from "@/components/sections/SectionThree";
import MeineVision from "@/components/sections/MeineVision";
import NextSteps from "@/components/sections/NextSteps";
import NewSectionFive from "@/components/sections/NewSectionFive";
import NewSectionSix from "@/components/sections/NewSectionSix";
import NewSectionSeven from "@/components/sections/NewSectionSeven";
import { AdminPasswordGate } from "@/components/admin/AdminPasswordGate";
import { useLocation } from "react-router-dom";
import { useSectionVisibility } from "@/hooks/useSectionVisibility";

const Index = () => {
  const location = useLocation();
  const { isSectionVisible } = useSectionVisibility();

  // Handle scroll to section from location state
  useEffect(() => {
    if (location.state?.scrollToId) {
      const element = document.getElementById(location.state.scrollToId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);


  return (
    <div className="min-h-screen bg-[#243949]">
      <Navigation />
      <section id="ns1">
        <NewBanner />
      </section>
      <div className="h-4 bg-[#9F9EA1]" />
      <section id="ns2">
        <MeineVision />
      </section>
      {isSectionVisible("ns3") && (
        <>
          <div className="h-4 bg-[#9F9EA1]" />
          <section id="ns3">
            <SectionThree />
          </section>
        </>
      )}
      {isSectionVisible("ns4") && (
        <>
          <div className="h-4 bg-[#9F9EA1]" />
          <section id="ns4">
            <NextSteps />
          </section>
        </>
      )}
      {isSectionVisible("ns5") && (
        <>
          <div className="h-4 bg-[#9F9EA1]" />
          <section id="ns5">
            <NewSectionTwo />
          </section>
        </>
      )}
      {isSectionVisible("ns6") && (
        <>
          <div className="h-4 bg-[#9F9EA1]" />
          <section id="ns6">
            <NewSectionFive />
          </section>
        </>
      )}
      {isSectionVisible("ns7") && (
        <>
          <div className="h-4 bg-[#9F9EA1]" />
          <section id="ns7">
            <NewSectionSix />
          </section>
        </>
      )}
      {isSectionVisible("ns8") && (
        <>
          <div className="h-4 bg-[#9F9EA1]" />
          <section id="ns8">
            <NewSectionSeven />
          </section>
        </>
      )}

      <AdminPasswordGate />
    </div>
  );
};

export default Index;
